import { render, staticRenderFns } from "./v3_mobile.vue?vue&type=template&id=67ff78ee&scoped=true&"
import script from "./v3_mobile.vue?vue&type=script&lang=js&"
export * from "./v3_mobile.vue?vue&type=script&lang=js&"
import style0 from "./v3_mobile.vue?vue&type=style&index=0&id=67ff78ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ff78ee",
  null
  
)

export default component.exports